import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 17a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-0"}],["path",{"d":"M14.42 14.45a3 3 0 1 0 4.138 4.119","key":"svg-1"}],["path",{"d":"M9 17v-8m0 -4v-1h10v11","key":"svg-2"}],["path",{"d":"M12 8h7","key":"svg-3"}],["path",{"d":"M3 3l18 18","key":"svg-4"}]]

const IconMusicOff = createReactComponent('outline', 'music-off', 'MusicOff', __iconNode);

export default IconMusicOff;